import { useQuery } from 'react-query';
import { axios } from '@/lib/axios';
import { useNotificationStore } from '@/stores/notifications';
import storage from '@/utils/storage';
import { API_URL } from '@/config';

export const getProjectById = async (project_id: any): Promise<any> => {
  const access_token = storage.getToken();

  if (!access_token || !project_id) {
    return;
  }

  try {
    const response = await axios.get(`${API_URL}/v2/project/${project_id}`);
    return response?.data;
  } catch (error) {
    // throw error;
  }
};

export const useGetProjectById = (project_id: any, config = {}) => {
  const { addNotification } = useNotificationStore();

  return useQuery<any, Error>(['project', project_id], () => getProjectById(project_id), {
    onError: (error: any) => {
      addNotification({
        type: 'error',
        title: 'Failed to fetch project',
        message: error.response?.data?.data || error.message,
      });
    },
    onSuccess: (data) => {},
    ...config,
  });
};
